export default {
  SET_SUB_USER_COIN_BALANCE(state, { coin, amount, id }) {
    state.sub[id].balance[coin] = amount;
  },

  SET_SUB_IDENTIFIERS(state, subsIdentifiers) {
    subsIdentifiers.forEach((identifier) => {
      state.sub[identifier.id] = {
        identifier,
      };
    });
  },
};
